<template>
<Dialog v-model="visible" :width="640" :max-width="1280" setting @setting="$emit('setting')">

  <template slot="title">
    <span class="title">{{ $t('type.SMOKE') }}</span>
  </template>

  <v-data-table :headers="headers" :items="items" :loading="loading" :footer-props="footers" :no-data-text="$t('history.no_data_available')" item-key="time" calculate-widths disable-sort>
    <template v-slot:item.smokeState="{ item }">
      <span class="font-weight-bold" :class="getClass(item.smokeState)">{{ $t(`smoke.${item.smokeState}`) }}</span>
    </template>
  </v-data-table>

</Dialog>
</template>

<script>
import Dialog from '@/components/utils/dialog/Dialog'
import HistoryDialog from '@/components/history/HistoryDialog'

export default {
  name: 'SmokeHistoryDialog',
  mixins: [HistoryDialog],
  components: {
    Dialog
  },
  computed: {
    headers() {
      return [{
        text: this.$t('history.time'),
        value: 'timeText',
      }, {
        text: this.$t('history.state'),
        value: 'smokeState',
        align: 'center'
      }];
    }
  },
  methods: {
    getClass(state) {
      switch (state) {
        case 'ALARM':
          return 'red--text';
        default:
          return 'grey--text';
      }
    }
  }
}
</script>
